import { RouteObject } from 'react-router-dom';

import { BaseModule } from 'lib/modules';

/**
 * Documents (Paper Trail) Module Implementation
 *
 * Owns no routes of its own: the browser page is a tab under the
 * `/processor/:tab?` catch-all, and the per-record panels are tabs on the
 * customer and job detail pages. Those call sites gate themselves on
 * `ModuleId.DOCUMENTS`; this registration is what makes the module toggleable
 * and what the nav filter checks.
 */
class DocumentsModuleClass extends BaseModule {
  id = 'DOCUMENTS';
  name = 'Documents';
  label = 'Documents';
  description = 'Document management, versioning, and generated-PDF auto-save';
  version = '1.0.0';

  createRoutes = (): RouteObject[] => [];
}

// Export singleton instance
export const DocumentsModule = new DocumentsModuleClass();
